import { DefaultLayout } from '@fondationcss/ui';

export const getCustomRoutes = () => [
  {
    path: '/',
    component: DefaultLayout,
    meta: { title: 'Scheduler' },
    children: [
      {
        // The home page answers the central question — faster, and of better
        // quality? — instead of dumping the job list.
        name: 'overview',
        path: '',
        component: () => import('@/views/overview-view.vue'),
      },
      {
        name: 'jobs',
        path: 'jobs',
        component: () => import('@/views/jobs-view.vue'),
      },
      {
        name: 'job-detail',
        path: 'jobs/:id',
        component: () => import('@/views/job-detail-view.vue'),
      },
      {
        name: 'queue',
        path: 'file',
        component: () => import('@/views/queue-view.vue'),
      },
      {
        name: 'comparison',
        path: 'comparaison',
        component: () => import('@/views/comparison-view.vue'),
      },
      {
        name: 'environments',
        path: 'environnements',
        component: () => import('@/views/environments-view.vue'),
      },
      {
        name: 'tenants',
        path: 'locataires',
        component: () => import('@/views/tenants-view.vue'),
      },
      {
        name: 'images',
        path: 'versions',
        component: () => import('@/views/images-view.vue'),
      },
      // Kept: it groups tenants and versions on a single page. The two dedicated
      // pages above replace it in the menu, but an existing bookmark must not land
      // on a 404.
      {
        name: 'administration',
        path: 'administration',
        component: () => import('@/views/administration-view.vue'),
      },
    ],
  },
];
